const initialState = {
	membersWorkoutsSelectedCategories: [0],
	membersWorkoutsSearchTerm: "",
	membersWorkoutsSelectedEquipment: [],
	membersWorkoutsSelectedTrainers: [],
	membersWorkoutsSelectedMusic: [],
	membersWorkoutsSelectedDuration: [],
};

export default initialState;
